import {CLIENT_SIGNUP_WORKFLOW_CANCELED_EVENT} from './client-signup-events';

const SIGNUP_WORKFLOW = {
    PROJECT_SUBMISSION: 'project-submission',
    COMPANY_INVITATION: 'company-invitation',
};

Hop.defineModule('email-validation-check', (el, {pa, signupWorkflow}) => {
    let checkProgressTimoutId;

    if (!pa) {
        throw new Error('Missing parameter "pa"');
    }

    if (signupWorkflow !== SIGNUP_WORKFLOW.COMPANY_INVITATION && signupWorkflow !== SIGNUP_WORKFLOW.PROJECT_SUBMISSION) {
        throw new Error(`signup workflow must be one of ${SIGNUP_WORKFLOW.PROJECT_SUBMISSION} or ${SIGNUP_WORKFLOW.COMPANY_INVITATION}`);
    }

    const resendLink = el.querySelector('#resendAddressValidationEmail a');

    function uponCheckResult(locationToWhichRedirectUser) {
        if (locationToWhichRedirectUser) {
            window.location = locationToWhichRedirectUser;
        } else {
            checkProgressTimoutId = scheduleNextCheck();
        }
    }

    function askWhetherEmailHasBeenValidated() {
        fetch(`/api/signup-progress/${pa}`, {
            method: 'get',
            credentials: 'same-origin',
        })
            .then((res) => (res.status === 200 ? res.json() : null))
            .then((maybeObj) => uponCheckResult(maybeObj && maybeObj.locationToWhichRedirectUser));
    }

    function scheduleNextCheck() {
        return window.setTimeout(askWhetherEmailHasBeenValidated, 2000);
    }

    function clearCheckProgressTimeoutId() {
        window.clearTimeout(checkProgressTimoutId);
    }

    function cancelCheckProgress(form) {
        clearCheckProgressTimeoutId();
        if (form) {
            form.submit();
        }
    }

    if (resendLink) {
        let debouncedSendValidationEmail = false;
        let sendValidationEmail = () => {
            Hop.post(`/api/signup-progress/${pa}/validation-email-sending`, JSON.stringify({workflow: signupWorkflow}), {
                'Content-Type': 'application/json',
            });

            // even tough the server will prevent too much sendings, there's no point in letting the
            // user click furiously on that link
            if (!debouncedSendValidationEmail) {
                sendValidationEmail = Hop.debounce(sendValidationEmail, 5 * 1000);
                debouncedSendValidationEmail = true;
            }
        };

        resendLink.addEventListener('click', (e) => {
            e.preventDefault();
            sendValidationEmail();
        });
    }

    Hop.events.on(CLIENT_SIGNUP_WORKFLOW_CANCELED_EVENT, cancelCheckProgress);

    checkProgressTimoutId = scheduleNextCheck();

    return function destroy() {
        clearCheckProgressTimeoutId();
        Hop.events.off(CLIENT_SIGNUP_WORKFLOW_CANCELED_EVENT, cancelCheckProgress);
    };
});
